import styles from './ImageSlidesDesktop.module.scss';

import cx from 'classnames';
import React, { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

import type { ContentImageEntry } from 'api/contentful/contentTypes.cloverdotcom';
import { ContentImage } from 'components/ContentImage/ContentImage';

enum ImageSlidesDesktopVariant {
  Product = 'product',
  ImagesOnly = 'images-only',
}

interface IImageSlidesDesktopProps {
  images?: ContentImageEntry[];
  variant?: ImageSlidesDesktopVariant;
}

export const ImageSlidesDesktop: FC<IImageSlidesDesktopProps> = ({
  images,
  variant = ImageSlidesDesktopVariant.Product,
}) => {
  const { t } = useTranslation();

  if (!images) return null;

  const config: ComponentProps<typeof Slider> = {
    className: 'product-desktop-slider',
    dots: true,
    dotsClass: styles.productSlides,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    customPaging(slideIndex: number) {
      const image = images[slideIndex];
      const src = image?.file?.url ?? null;
      const alt = image?.title ?? t('slide') + slideIndex;

      if (!src) return <></>;

      return (
        <button className={styles.sliderThumbButton}>
          <img src={src} height="64" width="64" alt={alt} className={styles.sliderIcon} />
        </button>
      );
    },
  };

  return (
    <div>
      <Slider {...config}>
        {images.map(image => (
          <div className={styles.slickSlider} key={image.id}>
            <ContentImage entry={image} className={cx(styles.sliderImage, styles[variant])} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

ImageSlidesDesktop.displayName = 'ImageSlidesDesktop';
